import React from 'react'

import { CopyableText } from '@components/common/CopyableText'
import { Loader, Tooltip } from '@fourthwall/components'
import type { DnsRecordAlias } from '@fourthwall/services/dist/DnsApiClient'

import * as S from './DnsRecordCodeCell.styled'

type DnsRecordCodeCellProps = {
  value: string
  recordAlias: DnsRecordAlias
}

const mapAliasToLoaderTooltip = (alias: DnsRecordAlias) => {
  switch (alias) {
    case 'SENDGRID_MAIL_CNAME':
    case 'SENDGRID_DOMAIN_KEY1':
    case 'SENDGRID_DOMAIN_KEY2':
      return 'We are waiting for SendGrid to let us know what you should input in that instance'
    case 'ZENDESK_VERIFICATION':
      return 'We are waiting for Zendesk to let us know what you should input in that instance'
    default:
      return 'We are waiting for one of external services to let us know what you should input in that instance'
  }
}

export const DnsRecordCodeCell = ({ value, recordAlias }: DnsRecordCodeCellProps) => {
  if (value?.length) {
    return (
      <CopyableText text={value}>
        <S.CodeCell pointer>{value}</S.CodeCell>
      </CopyableText>
    )
  }

  if (value === '') return <S.CodeCell>&nbsp;</S.CodeCell>

  return (
    <Tooltip reference={<Loader size="small" />} placement="top" fluid>
      {mapAliasToLoaderTooltip(recordAlias)}
    </Tooltip>
  )
}
